export const getMergeSort = (arr, animations) => {
  //Create two arrays for sorting
  let sorted = Array.from(arr);
  let n = sorted.length;
  let buffer = new Array(n);
  
  for (let size = 1; size < n; size *= 2) {
    for (let leftStart = 0; leftStart < n; leftStart += 2*size) {
      
      //Get the two sub arrays
      let left = leftStart,
          right = Math.min(left + size, n),
          leftLimit = right,
          rightLimit = Math.min(right + size, n);
      
      //Merge the sub arrays
      merge(left, right, leftLimit, rightLimit, sorted, buffer,animations);  
    }
    
    //Swap the sorted sub array and merge them
    let temp = sorted;
    sorted = buffer;
    buffer = temp;
  }
  
  return sorted;
}

const merge = (left, right, leftLimit, rightLimit, sorted, buffer,animations) => {
  let i = left;
  
  //Compare the two sub arrays and merge them in the sorted order
  while (left < leftLimit && right < rightLimit) {
    animations.push([left,right]);
    animations.push([left,right]);
    if (sorted[left] <= sorted[right]) {
      animations.push([i,sorted[left]]);
      buffer[i++] = sorted[left++];
    } else {
      animations.push([i,sorted[right]]);
      buffer[i++] = sorted[right++];
    }
  }

  //If there are elements in the left sub arrray then add it to the result
  while (left < leftLimit) {
    animations.push([left,left]);
    animations.push([left,left]);
    animations.push([i,sorted[left]]);
    buffer[i++] = sorted[left++];
  }

  //If there are elements in the right sub array then add it to the result
  while (right < rightLimit) {
    animations.push([right,right]);
    animations.push([right,right]);
    animations.push([i,sorted[right]]);
    buffer[i++] = sorted[right++];
  }
}